import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

export default class extends Controller {
  static values = { targetId: String }

  connect() {
    if (!this.hasTargetIdValue || this.targetIdValue.length === 0) return

    this.hasShown = false
    this.boundScheduleShow = this.scheduleShow.bind(this)
    document.addEventListener("turbo:load", this.boundScheduleShow)
    this.scheduleShow()
  }

  disconnect() {
    window.clearTimeout(this.showTimeout)
    if (this.boundScheduleShow) {
      document.removeEventListener("turbo:load", this.boundScheduleShow)
    }
  }

  scheduleShow() {
    window.clearTimeout(this.showTimeout)
    this.showTimeout = window.setTimeout(() => {
      window.requestAnimationFrame(() => this.show())
    }, 80)
  }

  show() {
    if (this.hasShown) return

    const modalElement = document.getElementById(this.targetIdValue)
    if (!modalElement) return

    document.querySelectorAll(".modal.show").forEach((openModal) => {
      if (openModal.id === this.targetIdValue) return

      Modal.getInstance(openModal)?.hide()
    })

    document.querySelectorAll(".modal-backdrop").forEach((backdrop) => backdrop.remove())
    document.body.classList.remove("modal-open")
    document.body.style.removeProperty("overflow")
    document.body.style.removeProperty("padding-right")

    this.hasShown = true
    Modal.getOrCreateInstance(modalElement).show()
  }
}
